import { VOID_TID } from "Constants";
import { useQueryParamString } from "polyrouter";
import { accountLimit } from "Constants";
import { useTenantsListQuery } from "generated/graphql";
import { useAuth0 } from "@auth0/auth0-react";

export type SelectedTenant = "tenantId";

/**
 * Returns the actively selected tenant id in the app or undefined
 */
export function useUnsafeTenantId(): undefined | string {
  const [activeTenant] = useQueryParamString<SelectedTenant>("tenantId");
  if (activeTenant && activeTenant !== VOID_TID) {
    return activeTenant;
  }
  return undefined;
}

export function useSelectedTenants(): string[] {
  const tid = useUnsafeTenantId();
  if (tid) {
    return [tid];
  }
  return [];
}

export function useTenants() {
  const { isAuthenticated } = useAuth0();
  const userAuthenticated =
    process.env.NODE_ENV === "test" ? true : isAuthenticated;
  return useTenantsListQuery({
    variables: {
      limit: accountLimit
    },
    pause: !userAuthenticated
  });
}
